/** @jsx jsx */
import { jsx } from "theme-ui"
import { useEffect } from "react"
import PropTypes from "prop-types"

import ConsentGate from "./consent-gate"

import { ab } from "../theme"

// Default consent-gate copy for the b-ite embed. GUC's "Offene Stellen" is
// German-only, so the defaults are German. The consent category is DEV-4
// "zu klären" — b-ite loads a third-party script, so we fail closed to the
// strictest category until GBA-Datenschutz confirms the final classification.
const DEFAULT_CONSENT_CATEGORY = "marketing"
const DEFAULT_INFO_TEXT =
  "Die Anzeige der offenen Stellen ist deaktiviert, solange die dafür erforderlichen Cookies nicht akzeptiert wurden."
const DEFAULT_BUTTON_TEXT = "Cookie-Einstellungen öffnen"

// Renders the b-ite jobs listing. Isolated so the loader script is only
// injected once this is mounted — i.e. after consent, when ConsentGate renders
// its children. Before consent it never mounts, so no empty gray slot shows.
const BIteEmbed = ({ listingId }) => {
  useEffect(() => {
    const script = document.createElement("script")
    script.src =
      "https://static.b-ite.com/jobs-api/loader-v1/api-loader-v1.min.js"
    script.async = false

    document.body.appendChild(script)
  }, [])

  return <div data-bite-jobs-api-listing={listingId}></div>
}

BIteEmbed.propTypes = {
  listingId: PropTypes.string.isRequired,
}

const JobsTable = ({
  anchorName,
  listingId,
  children,
  consentCategory,
  buttonText,
  infoText,
  infoUrl,
  infoUrlText,
}) => {
  return (
    <section
      id={anchorName ? anchorName : ""}
      sx={{
        bg: "secondaryBackground",
        variant: "guc.jobsTable",
      }}
    >
      <div
        sx={{
          variant: "innerSpacingContainer",
          pt: ab({ _: 3 }),
        }}
      >
        <h2>Offene Stellen</h2>
        <div
          sx={{
            display: children.length ? "block" : "none",
            overflow: "auto",
          }}
        >
          <table
            sx={{
              variant: "jobsTable",
            }}
          >
            <tr>
              <th>Stellenbezeichnung</th>
              <th>Ort</th>
              <th>&nbsp;</th>
            </tr>
            {children}
          </table>
        </div>
        <ConsentGate
          category={consentCategory}
          buttonText={buttonText}
          infoText={infoText}
          infoUrl={infoUrl}
          infoUrlText={infoUrlText}
        >
          <BIteEmbed listingId={listingId} />
        </ConsentGate>
      </div>
    </section>
  )
}

JobsTable.propTypes = {
  anchorName: PropTypes.string,
  listingId: PropTypes.string.isRequired,
  children: PropTypes.node,
  consentCategory: PropTypes.string,
  buttonText: PropTypes.string,
  infoText: PropTypes.string,
  infoUrl: PropTypes.string,
  infoUrlText: PropTypes.string,
}

JobsTable.defaultProps = {
  consentCategory: DEFAULT_CONSENT_CATEGORY,
  buttonText: DEFAULT_BUTTON_TEXT,
  infoText: DEFAULT_INFO_TEXT,
}

export default JobsTable
